module.exports = __webpack_public_path__ + "media/images/default_thumbnail-956999c29d9ff1b812e5050111bb203d.svg";